import { TextField, InputAdornment, Button } from "@mui/material";
import { Save } from "@mui/icons-material";
import { useForm } from "react-hook-form";
import { useRequest } from "../../../../app/helpers/network";
import {
  fetchLatestWorkBlock,
  updateLatestWorkBlock,
} from "../../services/latest-works.service";
import styled from "@emotion/styled";
import { HorizontalSpacer } from "../../components/Spacer";
import { buttons } from "../../lang/admin.strings";

const FlexRow = styled.div`
  display: flex;
`;

const ErrorMessage = styled.span`
  color: #cc0000;
`;

export const LatestWorksTab = () => {
  const { data, inProgress, errors } = useRequest(fetchLatestWorkBlock);
  const save = (data) => updateLatestWorkBlock(data);

  if (errors) {
    return (
      <>
        Oops Something went wrong! reason: <ErrorMessage>{errors}</ErrorMessage>
      </>
    );
  }

  return inProgress ? (
    <>ładowanie danych ...</>
  ) : (
    !!data && <LatestWorksForm data={data} onSubmit={save} />
  );
};

const LatestWorksForm = ({ data, onSubmit }) => {
  const { register, handleSubmit } = useForm();

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <FlexRow>
        <TextField
          sx={{ width: "100%" }}
          placeholder="Tytuł PL"
          label="Tytuł PL"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">PL</InputAdornment>
            ),
          }}
          {...register("title_pl", { value: data.title_pl })}
        />
        <HorizontalSpacer />
        <TextField
          sx={{ width: "100%" }}
          placeholder="Tytuł ENG"
          label="Tytuł ENG"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">ENG</InputAdornment>
            ),
          }}
          {...register("title_eng", { value: data.title_eng })}
        />
      </FlexRow>
      <br />
      <FlexRow>
        <TextField
          sx={{ width: "100%" }}
          placeholder="Opis PL"
          label="Opis PL"
          multiline
          rows={8}
          {...register("description_pl", { value: data.description_pl })}
        />
        <HorizontalSpacer />
        <TextField
          sx={{ width: "100%" }}
          placeholder="Opis ENG"
          label="Opis ENG"
          multiline
          rows={8}
          {...register("description_eng", { value: data.description_eng })}
        />
      </FlexRow>
      <br />
      <br />
      <Button type="submit" variant="contained" startIcon={<Save />}>
      {buttons.save}
      </Button>
    </form>
  );
};
